/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SourceSiteView { 
    connectionSiteId?: string;
    provider?: SourceSiteView.ProviderEnum;
    displayName?: string;
    webUrl?: string;
    tenantDomain?: string;
}
export namespace SourceSiteView {
    export type ProviderEnum = 'SHAREPOINT';
    export const ProviderEnum = {
        SHAREPOINT: 'SHAREPOINT' as ProviderEnum
    };
}